// Status do orçamento (Proposal::status na API), na ordem do ciclo de vida.
// Cor, ícone e palavra seguem o Badge `status` do design system Orca App.
export interface ProposalStatusInfo {
    key: 'criado' | 'enviado' | 'aprovado' | 'reprovado' | 'faturado' | 'pago' | 'expirado';
    label: string;
    icon: string;
}

export const PROPOSAL_STATUSES: Record<number, ProposalStatusInfo> = {
    1: { key: 'criado', label: 'Criado', icon: 'edit_note' },
    2: { key: 'enviado', label: 'Enviado', icon: 'send' },
    3: { key: 'aprovado', label: 'Aprovado', icon: 'thumb_up' },
    4: { key: 'reprovado', label: 'Reprovado', icon: 'thumb_down' },
    5: { key: 'faturado', label: 'Faturado', icon: 'receipt_long' },
    6: { key: 'pago', label: 'Pago', icon: 'paid' },
    7: { key: 'expirado', label: 'Expirado', icon: 'timer_off' },
};

export function proposalStatusInfo(status: number | string | null | undefined): ProposalStatusInfo | null {
    return PROPOSAL_STATUSES[Number(status)] ?? null;
}
